import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import InboxOutlinedIcon from "@material-ui/icons/InboxOutlined";

/**
 * Estado vazio padrão.
 *
 * Nasceu dentro do DataTable e saiu de lá quando a tela de Conexões — que é
 * uma grade de cartões, não uma tabela — precisou do mesmo desenho. Manter as
 * duas versões significaria ter dois "nada aqui" diferentes no mesmo produto.
 *
 * A descrição não é enfeite: uma lista vazia sem explicação é indistinguível
 * de uma lista quebrada. Diga o que aquilo guarda e como aparece o primeiro
 * registro.
 */
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(7, 3),
    textAlign: "center",
  },
  icon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(0.5),
    color: theme.palette.text.hint,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(148,163,184,0.10)"
        : theme.palette.grey[100],
  },
  description: {
    color: theme.palette.text.secondary,
    maxWidth: 380,
  },
  action: {
    marginTop: theme.spacing(1.5),
  },
}));

const EmptyState = ({ icon, title, description, action }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.icon}>{icon || <InboxOutlinedIcon />}</div>
      <Typography variant="subtitle1">{title}</Typography>
      {description && (
        <Typography variant="body2" className={classes.description}>
          {description}
        </Typography>
      )}
      {action && <div className={classes.action}>{action}</div>}
    </div>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  /** Ação que resolve o vazio — normalmente o mesmo botão do cabeçalho. */
  action: PropTypes.node,
};

EmptyState.defaultProps = {
  icon: undefined,
  description: undefined,
  action: undefined,
};

export default EmptyState;
